/* Polsk katalog for locale-bank-misc-no.js (del 2 av 3).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'km.privateDrivingHelp': 'Użytek prywatny jest udokumentowany w ewidencji przebiegu, ale nie daje odliczenia.',
  'km.filterType': 'Typ',
  'km.tryOtherSearch': 'Spróbuj innego wyszukiwania lub wyczyść filtr.',
  'km.distance': 'Dystans',
  'km.stops': 'Przystanki',
  'km.returnYes': 'Tak ({km} km w każdą stronę)',
  'km.returnNo': 'Nie',
  'km.status': 'Status',
  'km.statusLogged': 'Zarejestrowano',
  'km.statusPosted': 'Zaksięgowano',
  'km.route': 'Trasa',
  'km.amount': 'Kwota',
  'km.deleteTripBody': 'Czy na pewno chcesz usunąć tę trasę{route}? Tej operacji nie można cofnąć.',
  'km.speedUnit': 'km/h',
  'km.gps.unavailable': 'GPS nie jest dostępny w tej przeglądarce.',
  'km.gps.denied': 'Odmówiono dostępu do GPS lub nie udało się go uruchomić.',
  'km.gps.active': 'GPS aktywny',
  'km.gps.inactive': 'GPS nie jest aktywny',
  'km.gps.stop': 'Zakończ trasę',
  'km.gps.start': 'Rozpocznij trasę',
  'km.gps.done': 'Trasa zakończona',
  'km.gps.tracking': 'Śledzenie Twojej pozycji.',
  'km.gps.doneHint': 'Zarejestrowano {km} km. Użyj dystansu w formularzu poniżej.',
  'km.gps.startHint': 'Rozpocznij trasę, aby włączyć śledzenie GPS.',
  'km.toast.editTrip': 'Edytuj trasę - zmień ją i zapisz ponownie',
  'km.toast.openedNotFound': 'Otwarto ewidencję przebiegu. Nie znaleziono dokładnej trasy do automatycznej edycji.',
  'km.toast.fillFromTo': 'Najpierw wypełnij co najmniej adres początkowy i docelowy.',
  'km.toast.calcUnavailable': 'Automatyczne obliczanie km nie jest jeszcze dostępne.',
  'km.toast.distanceFailed': 'Nie udało się obliczyć odległości.',
  'km.toast.kmCalculated': 'Kilometry obliczone automatycznie',
  'km.toast.calcFailed': 'Nie udało się automatycznie obliczyć kilometrów.',
  'km.toast.fillPrivate': 'Wypełnij datę, skąd, dokąd i kilometry przed zapisaniem przejazdu prywatnego.',
  'km.toast.fillBusiness': 'Wypełnij datę, skąd, dokąd, cel i kilometry przed zapisaniem.',
  'km.toast.updated': 'Przejazd został zaktualizowany',
  'km.toast.saved': 'Przejazd został zapisany',
  'km.toast.deleted': 'Usunięto przejazd',
  'bank.filter.all': 'Wszystkie',
  'bank.filter.processing': 'Do przetworzenia',
  'bank.filter.suggestion': 'Sugestia gotowa',
  'bank.filter.control': 'Wymaga kontroli',
  'bank.filter.missing': 'Brak dokumentu',
  'bank.filter.deviation': 'Możliwa rozbieżność',
  'bank.filter.done': 'Gotowe',
  'bank.typeGroup.sales': 'Sprzedaż',
  'bank.typeGroup.purchase': 'Zakupy',
  'bank.typeGroup.other': 'Inne',
  'bank.typeGroup.tax': 'Podatki i opłaty',
  'bank.typeGroup.loan': 'Kredyty i zobowiązania',
  'bank.type.invoicePayment': 'Płatność faktury',
  'bank.type.otherSales': 'Inna sprzedaż',
  'bank.type.payOpenSupplier': 'Faktura od dostawcy: zapłać otwartą',
  'bank.type.newSupplier': 'Faktura od dostawcy: zarejestruj nową',
  'bank.type.purchase': 'Zwykły zakup',
  'bank.type.free': 'Dowolne księgowanie',
  'bank.type.fee': 'Opłata',
  'bank.type.rounding': 'Różnica z zaokrągleń',
  'bank.type.owner': 'Wypłata / wpłata prywatna',
  'bank.type.vat': 'Płatność VAT',
  'bank.type.payroll': 'Zaliczka na podatek / AGA',
  'bank.type.tax': 'Płatność podatku',
  'bank.type.loan': 'Kredyt / zobowiązanie',
  'bank.agaPart.withholding': 'Zaliczka na podatek na konto 2600',
  'bank.agaPart.employer': 'Składka pracodawcy na konto 2770',
  'bank.agaPart.both': 'Obie łącznie, rozdzielone na 2600 i 2770',
  'bank.vat.none': 'Bez VAT',
  'bank.vat.input': '{{code}} - VAT naliczony {{rate}} %',
  'bank.accountFallback': 'Konto {{code}}',
  'bank.countsAsZero': '{{note}} · liczone jako 0,00 kr w uzgodnieniu',
  'bank.csv.date': 'Data',
  'bank.csv.description': 'Opis',
  'bank.csv.note': 'Notatka',
  'bank.csv.amount': 'Kwota',
  'bank.csv.balance': 'Saldo',
  'bank.posted.amount': 'Zaksięgowano {{amount}}',
  'bank.posted': 'Zaksięgowano',
  'bank.posted.vatAmount': 'VAT {{amount}} ({{rate}} %)',
  'bank.posted.vatRate': 'VAT {{rate}} %',
  'bank.err.pickSupplierInvoice': 'Wybierz fakturę od dostawcy, której dotyczy płatność.',
  'bank.err.supplierPaymentMustBeOutgoing': 'Płatność faktury od dostawcy musi być wypłatą z banku.',
  'bank.err.supplierPaymentUnavailable': 'Płacenie faktur od dostawców z banku nie jest jeszcze dostępne.',
  'bank.deviation.intro': 'Te pozycje są zaksięgowane na rachunku bankowym, ale Plumme nie znajduje pewnej linii bankowej, która by je wyjaśniała.',
  'bank.deviation.none': 'Brak możliwych rozbieżności w tym okresie.',
  'bank.detail.date': 'Data',
  'bank.detail.amount': 'Kwota',
  'bank.detail.status': 'Status',
  'bank.detail.postId': 'ID pozycji',
  'bank.detail.type': 'Typ',
  'bank.detail.period': 'Okres',
  'bank.detail.noReceipt': 'Z księgowaniem nie powiązano żadnego dokumentu',
  'bank.detail.receiptPreviewable': 'Podgląd dokumentu jest dostępny bezpośrednio tutaj.',
  'bank.detail.noPreview': 'Brak dokumentu do podglądu.',
  'bank.toast.postingCorrected': 'Zaksięgowany zapis został skorygowany',
  'bank.toast.postingVoided': 'Księgowanie zostało anulowane. Ewentualny dokument wrócił do skrzynki odbiorczej.',
  'bank.transition.review': 'Sprawdź przejście z zaimportowanych ksiąg, zanim ten wyciąg zostanie zaksięgowany.',
  'bank.transition.fixOpening': '{{message}} Popraw saldo początkowe przed zaksięgowaniem.',
  'bank.toast.voucherLinkedName': 'Powiązano dokument: {{name}}',
  'bank.toast.noVoucherSuggestions': 'SuperPlumma nie ma sugestii dokumentów do powiązania.',
  'bank.toast.oneVoucherLinked': 'Powiązano jeden dokument',
  'bank.toast.nVouchersLinked': 'Powiązane dokumenty: {{count}}',
  'bank.toast.linkSuggestedFailed': 'Nie udało się powiązać sugerowanych dokumentów.',
  'bank.toast.linkedToPosted': 'Linia bankowa została powiązana z już zaksięgowaną pozycją',
  'bank.toast.linkToPostedFailed': 'Nie udało się powiązać linii bankowej z zaksięgowaną pozycją.',
  'bank.toast.saveCustomerFirst': 'Zapisz klienta przed zatwierdzeniem linii.',
  'bank.toast.saveSupplierFirst': 'Zapisz lub wybierz dostawcę przed zatwierdzeniem linii.',
  'bank.toast.reviewSuggestionFirst': 'Sprawdź sugestię w linii bankowej przed zatwierdzeniem.',
  'bank.toast.invoicePaymentDone': 'Płatność faktury została zaksięgowana, a linia bankowa jest gotowa',
  'bank.toast.supplierPaymentDone': 'Faktura od dostawcy została opłacona, a linia bankowa jest gotowa',
  'bank.toast.enterSupplierName': 'Wpisz nazwę dostawcy przed zatwierdzeniem faktury.',
  'bank.toast.enterInvoiceNumber': 'Wpisz numer faktury przed jej zatwierdzeniem.',
  'bank.toast.checkCostAccount': 'Sprawdź konto kosztowe przed zatwierdzeniem faktury.',
  'bank.toast.supplierInvoiceDone': 'Faktura od dostawcy została zaksięgowana, a linia bankowa jest gotowa',
  'bank.toast.suggestionDone': 'Sugestia została zaksięgowana, a linia bankowa jest gotowa',
  'bank.toast.alreadyDone': 'Linia bankowa jest już zaksięgowana i gotowa',
  'bank.toast.suggestionNotApproved': 'Nie udało się zatwierdzić sugestii.',
  'bank.toast.suggestionNeedsReview': 'Sugestię należy sprawdzić przed zatwierdzeniem.',
  'bank.approve': 'Zatwierdź',
  'bank.toast.pickUnprocessed': 'Wybierz co najmniej jedną nieprzetworzoną linię bankową.',
  'bank.toast.approveLineFailed': 'Nie udało się zatwierdzić linii bankowej.',
  'bank.toast.nLinesApproved': 'Zatwierdzone linie: {{count}}',
  'bank.toast.lineAdded': 'Dodano linię bankową',
  'bank.toast.lineLinkUnavailable': 'Powiązywanie linii bankowych nie jest jeszcze dostępne.',
  'bank.toast.linkedToExistingPosted': 'Linia bankowa została powiązana z istniejącą zaksięgowaną pozycją',
  'bank.controlPosting.title': 'Zaksięgowana pozycja bankowa',
  'bank.controlPosting.sub': 'Możliwa rozbieżność: zaksięgowano na rachunku bankowym, ale nie znaleziono w wyciągu bankowym.',
  'bank.toast.openedAsDeviation': 'Linia bankowa została otwarta jako rozbieżność',
  'bank.toast.investmentMatchReopened': 'Powiązanie bankowe z inwestycją zostało zwolnione',
  'bank.toast.balanceCorrectionUnavailable': 'Korekta salda nie jest jeszcze dostępna.',
  'bank.toast.openingMustBeNumber': 'Saldo początkowe musi być liczbą.',
  'bank.toast.openingUpdated': 'Zaktualizowano saldo początkowe',
  'bank.toast.openingFromImport': 'Saldo początkowe ustawiono na podstawie przejścia z importu',
  'bank.toast.closingMustBeNumber': 'Saldo końcowe musi być liczbą.',
  'bank.toast.closingUpdated': 'Zaktualizowano saldo końcowe',
  'bank.toast.roundingMustBeNumber': 'Różnica z zaokrągleń musi być liczbą.',
  'bank.toast.roundingCorrected': 'Skorygowano różnicę z zaokrągleń',
  'bank.mark.posted': 'Zaksięgowano',
  'bank.mark.alreadyPosted': 'Już zaksięgowano',
  'bank.mark.approved': 'Zatwierdzono',
  'bank.mark.needsReview': 'Wymaga kontroli',
  'bank.mark.deviation': 'Możliwa rozbieżność',
  'bank.mark.suggestion': 'Sugestia gotowa',
  'bank.mark.private': 'Prywatne',
  'bank.mark.removed': 'Usunięto',
  'bank.mark.new': 'Nieprzetworzone',
  'bank.toast.analysisUnavailable': 'Analiza SuperPlumma nie jest jeszcze dostępna.',
  'bank.toast.foundSuggestions': 'SuperPlumma znalazła sugestie do sprawdzenia: {{count}}',
  'bank.toast.noSafeSuggestions': 'SuperPlumma nie znalazła pewnych sugestii',
  'bank.toast.analysisFailed': 'SuperPlumma nie mogła przeanalizować linii bankowych.',
  'bank.toast.alreadyArchived': 'Wyciąg bankowy jest już uzgodniony i zarchiwizowany.',
  'bank.toast.reconciledArchived': 'Wyciąg bankowy został uzgodniony i zarchiwizowany.',
  'bank.toast.reopenFailed': 'Nie udało się ponownie otworzyć uzgodnienia.',
  'bank.matchMultiple': 'Dopasuj kilka',
  'bank.transition.title': 'Sprawdź przejście z zaimportowanych ksiąg',
  'bank.transition.changeAnchor': 'Zmień „Uzgodniono do dnia” i saldo początkowe w Ustawieniach, jeśli punkt importu został ustawiony błędnie.',
  'bank.previousNotReconciled': 'Wcześniejszy okres nie jest uzgodniony',
  'bank.correctViaPencil': 'Popraw za pomocą ikony ołówka',
  'bank.correctReadBalance': 'Popraw odczytane saldo',
  'bank.analysis.alreadyDone': 'Wyciąg bankowy został już przeanalizowany. Nowa analiza jest zablokowana, aby uniknąć niepotrzebnego zużycia tokenów.',
  'bank.analysis.autoRunning': 'SuperPlumma automatycznie analizuje wyciąg bankowy.',
  'bank.analysis.analyzedShort': 'Przeanalizowane przez SuperPlumma',
  'bank.analysis.analyzingShort': 'SuperPlumma analizuje',
  'bank.archiveBlocked.chronological': 'Najpierw uzgodnij {{name}}. Uzgodnienie musi przebiegać chronologicznie, ponieważ saldo początkowe pochodzi z poprzedniego wyciągu.',
  'bank.archiveBlocked.deviation': 'Rozbieżność salda musi wynosić 0,00 kr, zanim wyciąg bankowy będzie mógł zostać zarchiwizowany.',
  'bank.archiveBlocked.lines': 'Wszystkie linie bankowe muszą zostać przetworzone, zanim wyciąg bankowy będzie mógł zostać zarchiwizowany.',
  'bank.reviewAndApprove': 'Sprawdź i zatwierdź',
  'bank.voucherN': 'Dokument {{n}}',
  'bank.voucherLinked': 'Dokument powiązany',
  'bank.showVoucher': 'Pokaż dokument',
  'bank.voucherSuggested': 'Dokument zasugerowany',
  'bank.voucherMissingBadge': 'Brak dokumentu',
  'bank.toast.linkRemoved': 'Powiązanie zostało usunięte. Dokument jest w skrzynce odbiorczej.',
  'bank.sendVouchersBack': 'Odeślij dokumenty do skrzynki odbiorczej',
  'bank.toast.vouchersSentBack': 'Dokumenty zostały odesłane do skrzynki odbiorczej',
  'bank.analysisHint.tap': 'Pozwól SuperPlumma przeanalizować wiersze i zaproponować księgowania albo dotknij dokumentu, a potem wiersza bankowego, aby je połączyć.',
  'bank.analysisHint.drag': 'Pozwól SuperPlumma przeanalizować wiersze i zaproponować księgowania albo przeciągnij dokument bezpośrednio na wiersz bankowy, aby je połączyć.',
  'bank.showInbox': 'Pokaż skrzynkę odbiorczą',
  'bank.toast.lineDone': 'Wiersz bankowy jest zaksięgowany i gotowy',
  'bank.toast.noInboxVouchers': 'Brak dokumentów w skrzynce odbiorczej do połączenia.',
  'bank.toast.balanceCorrected': 'Saldo zostało skorygowane',
  'bank.toast.misreadRemoved': 'Błędnie odczytany wiersz został usunięty z uzgadniania',
  'bank.toast.readingCorrected': 'Odczyt został poprawiony',
  'bank.toast.postedFixed': 'Zaksięgowana pozycja została poprawiona',
  'bank.toast.lineRemoved': 'Wiersz bankowy został usunięty z uzgadniania',
  'bank.vatTerm.jun': 'VAT {{year}} - 10 czerwca',
  'bank.vatTerm.apr': 'VAT {{year}} - 10 kwietnia',
  'bank.vatTerm.feb': 'VAT {{year}} - 10 lutego',
  'bank.vatTerm.aug': 'VAT {{year}} - 31 sierpnia',
  'bank.vatTerm.oct': 'VAT {{year}} - 10 października',
  'bank.vatTerm.dec': 'VAT {{year}} - 10 grudnia',
  'bank.agaTerm': 'Zaliczka na podatek/AGA, okres {{n}} {{year}}',
  'bank.ownerAccountFallback': 'Konto prywatne/właściciela',
  'bank.periodHint': 'Wyciąg bankowy obejmuje {{from}} - {{to}}.',
  'bank.voucher': 'Dokument',
  'bank.ownerType.withdrawal': 'Wypłata prywatna',
  'bank.ownerType.deposit': 'Wpłata prywatna',
  'bank.ownerType.both': 'Wypłata / wpłata prywatna',
  'bank.ownerType.owner': 'Właściciel / rozrachunki',
  'bank.vat86.prefix': 'Kwota dostawcy',
  'bank.vat86.suffix': 'stanowi podstawę. Kod 86 nalicza zarówno VAT należny, jak i naliczony według stawki 25 % bez zmniejszania kwoty bankowej.',
  'bank.postedWithoutVat': 'jest księgowane bez VAT.',
  'bank.withVatRate': 'z VAT {{rate}} %.',
  'bank.amountHelp.locked': 'Kwota pochodzi z wyciągu bankowego i nie można jej zmienić.',
  'bank.amountHelp.unlocked': 'Księgowanie nie jest połączone z wierszem bankowym, więc kwotę można tu poprawić. Zmiana zostanie zapisana w ścieżce audytu.',
  'bank.amountHelp.mustMatch': 'Kwota musi odpowiadać rzeczywistej transakcji bankowej.',
  'bank.err.enterAmount': 'Wpisz kwotę bankową, zanim zapiszesz wiersz.',
  'bank.err.dateWithinStatement': 'Data musi mieścić się w okresie wyciągu: {{from}} - {{to}}.',
  'bank.err.pickTwoAccountsFree': 'Wybierz dwa różne konta, zanim zapiszesz księgowanie dowolne.',
  'bank.err.enterSupplierName': 'Wpisz nazwę dostawcy, zanim zapiszesz fakturę zakupu.',
  'bank.err.enterInvoiceNumber': 'Wpisz numer faktury, zanim zaksięgujesz fakturę zakupu.',
  'bank.err.invoicePaymentIncoming': 'Płatność za fakturę musi być wpływem na rachunek bankowy.',
  'bank.err.pickInvoice': 'Wybierz fakturę, zanim zapiszesz płatność.',
  'bank.err.pickOwnerAccount': 'Wybierz konto prywatne/właściciela, zanim zatwierdzisz zapis.',
  'bank.err.pickLoanAccount': 'Wybierz konto pożyczki/zobowiązania lub użyj księgowania dowolnego.',
  'bank.err.loanSplitSum': 'Rata kapitałowa, odsetki i opłaty muszą sumować się do kwoty bankowej.',
  'bank.err.supplierPaymentOutgoing': 'Płatność faktury zakupu musi być wypływem z rachunku bankowego.',
  'bank.err.pickSupplierInvoiceBeforeSave': 'Wybierz fakturę zakupu, zanim zapiszesz płatność.',
  'bank.err.correctionReason': 'Krótko napisz, dlaczego księgowanie jest korygowane.',
  'bank.err.noReceiptReason': 'Podaj krótkie uzasadnienie, dlaczego osobny dowód księgowy nie jest potrzebny.',
  'bank.err.linkVoucherOrWaive': 'Połącz dokument albo zaznacz, że osobna dokumentacja nie istnieje lub nie jest potrzebna.',
  'bank.err.uploadUnavailable': 'Przesyłanie dokumentów nie jest jeszcze dostępne.',
  'bank.err.analysisFailedAfterUpload': 'Dokument został przesłany, ale analiza się nie powiodła.',
  'bank.toast.uploadedAndLinked': 'Dokument przesłany i połączony z wierszem bankowym.',
  'bank.toast.linkOnSaveCorrection': 'Dokument zostanie połączony po zapisaniu korekty.',
  'bank.toast.linkOnSaveLine': 'Dokument zostanie połączony po zapisaniu wiersza bankowego.',
  'bank.err.uploadFailed': 'Nie udało się przesłać dokumentu.',
  'bank.modal.correctPosting': 'Skoryguj księgowanie',
  'bank.modal.editLine': 'Edytuj wiersz bankowy',
  'bank.modal.saveCorrection': 'Zapisz korektę',
  'bank.modal.approveAndClose': 'Zatwierdź i zamknij',
  'bank.modal.fieldsLocked': 'Kwota bankowa, data, typ i powiązanie z bankiem są zablokowane. Konto, VAT i opis wewnętrzny można poprawić ze ścieżką audytu.',
  'bank.modal.correctionUnlocked': 'Księgowanie nie jest połączone z wierszem wyciągu bankowego. Datę, kwotę, konto, VAT, dokument i opis wewnętrzny można poprawić ze ścieżką audytu. Jeśli błędny jest sam typ księgowania, należy je anulować i zaksięgować ponownie.',
  'bank.modal.manualLineHelp': 'Używaj tego tylko wtedy, gdy w wyciągu brakuje rzeczywistej transakcji bankowej, np. z powodu błędu importu lub wiersza, który trzeba wprowadzić ręcznie przed uzgodnieniem.',
  'bank.help.sales': 'Sprzedaż używa domyślnego konta sprzedaży i ustawień VAT. Później zostanie to połączone z fakturą/KID, gdy będą dostępne.',
  'bank.help.ownerSole': '{{label}} jest księgowane między bankiem a wybranym kontem prywatnym bez przychodu, kosztu i VAT.',
  'bank.help.ownerUnknownEntity': 'Forma prawna nie jest ustawiona w ustawieniach, więc Plumme nie proponuje tu konta. Wybierz konto przeciwstawne sam lub ustaw formę prawną, aby otrzymać propozycję.',
  'bank.help.ownerIntercompany': 'To zapis na koncie rozrachunków z właścicielem, a nie prywatny zapis ENK. Wybierz udokumentowane konto przeciwstawne; pożyczki, dywidenda i wkłady kapitałowe muszą przejść właściwy proces.',
  'bank.label.privateAccount': 'Konto prywatne',
  'bank.label.ownerAccount': 'Konto rozrachunków z właścicielem',
  'bank.help.shareholderTitle': 'Wypłata ze spółki.',
  'bank.help.shareholderBody': 'Proponowane jest konto rozrachunków, bo zbiera relację z właścicielem w jednym saldzie. Jeśli nie jest to zwrot tego, co spółka jest Ci winna, staje się to pożyczką dla udziałowca: asl. §8-7 stawia wymogi co do pokrycia i zabezpieczenia, a sktl. §10-11 ust. 4 opodatkowuje ją u Ciebie jak dywidendę. Dywidendę i wynagrodzenie księguje się w osobnych procesach.',
  'bank.help.invoicePayment': 'Użyj tego, gdy wpływ na rachunek dotyczy istniejącej faktury sprzedaży. Księgowanie idzie na należność od klienta i wybrany rachunek bankowy.',
  'bank.settlement.linked': 'Połączono raport rozliczenia:',
  'bank.settlement.detail': 'faktura jest opłacona kwotą {{gross}}, opłata {{fee}}, wpływ netto {{payout}}.',
  'bank.help.noInvoiceMatch': 'Zmień kwotę lub użyj opcji Inna sprzedaż, jeśli wpływ nie dotyczy faktury.',
  'bank.help.supplierPayment': 'Użyj tego, gdy płatność z banku dotyczy już zarejestrowanej faktury zakupu. Płatność jest księgowana na zobowiązanie wobec dostawcy i wybrany rachunek bankowy.',
  'bank.pickOpenSupplierInvoice': 'Wybierz otwartą fakturę zakupu',
  'bank.supplierInvoiceRemaining': '{{number}} · {{supplier}} · pozostało {{amount}}',
  'bank.overpayment': 'Nadpłata {{amount}}.',
  'bank.overpaymentHelp': 'Cała kwota bankowa zostanie zarejestrowana na fakturze zakupu, a nadwyżka pozostanie jako należność od dostawcy.',
  'bank.noSupplierInvoiceFits': 'Żadna otwarta faktura od dostawcy nie pasuje do kwoty.',
  'bank.noSupplierInvoiceFitsHelp': 'W przypadku nadpłaty pozostałą kwotę należy dopasować do faktury, a nadwyżkę zaksięgować osobno.',
  'bank.help.taxPayment': 'Używaj tej opcji tylko dla płatności do Skatteetaten, które nie dotyczą konkretnego okresu VAT ani zaliczki na podatek/AGA.',
  'bank.selectedFeeAccount': 'wybrane konto opłat',
  'bank.selectedRoundingAccount': 'wybrane konto zaokrągleń',
  'bank.help.roundingWarning': 'Różnica z zaokrąglenia powinna zwykle wynosić mniej niż 1 kr. Większe rozbieżności trzeba wyjaśnić, sprawdzając saldo i linie bankowe.',
  'bank.help.free': 'Księgowanie dowolne służy do przelewów, zobowiązań, rozliczeń wewnętrznych, korekt lub innych zdarzeń bankowych, które nie są zwykłym zakupem, sprzedażą ani płatnością faktury.',
  'bank.help.newSupplierInvoice': 'Użyj tej opcji, gdy faktura od dostawcy nie jest jeszcze zarejestrowana. Linia bankowa zostanie zapisana ze szczegółami faktury od dostawcy, aby można ją było później powiązać.',
  'bank.correction.requiredHint': 'Wymagane. Zapisywane w ścieżce audytu.',
  'bank.correction.reasonPh': 'Krótko opisz, dlaczego księgowanie jest korygowane',
  'bank.noSeparateDoc.bank': 'Wyciąg bankowy jest dokumentacją – osobny dowód księgowy nie jest potrzebny',
  'bank.noSeparateDoc.other': 'Osobna dokumentacja nie istnieje lub nie jest potrzebna',
  'bank.shortReasonPh': 'Krótkie uzasadnienie',
  'bank.toast.pickFromInbox': 'Wybierz dokument ze skrzynki odbiorczej, a nie z Dokumentacji.',
  'bank.toast.linkedOnCorrection': 'Dokument zostanie powiązany po zapisaniu korekty.',
  'bank.toast.linkedToLine': 'Dokument został powiązany z linią bankową.',
  'bank.priv.filterAll': 'Wszystkie',
  'bank.priv.filterOperating': 'Działalność',
  'bank.priv.filterNew': 'Nieprzetworzone',
  'bank.priv.filterIgnore': 'Ignoruj',
  'bank.priv.statusIgnored': 'Zignorowano',
  'bank.priv.noSafeMatches': 'Brak jeszcze pewnych dopasowań dokumentów do powiązania',
  'bank.priv.linkedN': 'Powiązano dokumenty z prywatnymi liniami bankowymi: {{count}}',
  'bank.priv.pickOneLine': 'Wybierz co najmniej jedną linię bankową.',
  'bank.priv.ignoredN': 'Zignorowane linie: {{count}}',
  'bank.priv.movedN': 'Linie przeniesione do działalności: {{count}}',
  'bank.priv.intro': 'Bank prywatny służy jako narzędzie porządkowe: oznacz linie związane z firmą jako Działalność i zignoruj linie prywatne lub nieistotne. To, co oznaczysz jako działalność, zostanie zaksięgowane na koncie firmowym.',
  'bank.priv.movedToOperating': 'Przeniesiono do działalności',
  'bank.priv.noteTap': 'Pozwól SuperPlumma powiązać je automatycznie albo dotknij dokumentu, a potem linii bankowej.',
  'bank.priv.noteDrag': 'Pozwól SuperPlumma powiązać je automatycznie albo przeciągnij dokument bezpośrednio na linię bankową.',
  'bank.toast.lineUpdated': 'Linia bankowa zaktualizowana',
  'bank.err.excelParserMissing': 'Parser Excel nie został załadowany.',
  'bank.err.pdfParserMissing': 'Parser PDF nie został załadowany.',
  'bank.toast.addBankAccountFirst': 'Najpierw dodaj konto bankowe w ustawieniach',
  'bank.err.archiveUnavailable': 'Archiwizacja wyciągów bankowych nie jest jeszcze dostępna.',
  'bank.toast.privateReviewArchived': 'Przegląd prywatny został zakończony i zarchiwizowany',
  'bank.err.archiveFailed': 'Nie udało się zarchiwizować wyciągu bankowego',
  'bank.err.reopenUnavailable': 'Ponowne otwieranie wyciągów bankowych nie jest jeszcze dostępne.',
  'bank.toast.statementReopened': 'Wyciąg bankowy został ponownie otwarty',
  'bank.err.reopenStatementFailed': 'Nie udało się ponownie otworzyć wyciągu bankowego',
  'bank.account.private': 'Konto prywatne',
  'bank.account.operating': 'Konto firmowe',
  'bank.group.operating': 'Konta firmowe',
  'bank.group.private': 'Konta prywatne',
  'bank.group.doneReviews': 'Zakończone przeglądy wyciągów prywatnych',
  'bank.group.doneReconciled': 'Zakończone uzgodnienia wyciągów bankowych',
  'bank.unknownPeriod': 'Nieznany okres',
  'bank.handledOf': 'Obsłużono {{handled}} z {{lines}}',
  'bank.page.privateTitle': 'Bank prywatny',
  'bank.page.title': 'Uzgodnienie bankowe',
  'bank.page.privateSubtitle': 'Uporządkuj konto prywatne - oznacz linie związane z firmą jako działalność i zignoruj resztę.',
  'bank.page.subtitle': 'Wgraj XLSX, CSV, PDF lub zrzut ekranu z banku, oznacz linie firmowe jako działalność i archiwizuj gotowe wyciągi.',
  'bank.tab.operating': 'Działalność',
  'bank.tab.private': 'Prywatne',
  'bank.tab.archive': 'Archiwum',
  'bank.page.privateUploadHelp': 'Wgraj tutaj wyciąg prywatny tylko wtedy, gdy chcesz znaleźć wydatki związane z firmą. Zostanie zapisany w wybranej firmie, ale bez konta bankowego z Ustawień.',
  'bank.noAccountRegistered': 'Brak zarejestrowanego konta bankowego',
  'bank.stmt.reviewed': 'Przejrzano',
  'bank.stmt.toReview': 'Do przeglądu',
  'bank.stmt.toReconcile': 'Do uzgodnienia',
  'bank.dropzone.uploadMore': 'Wgraj więcej wyciągów bankowych',
  'bank.dropzone.none': 'Brak jeszcze wyciągów bankowych',
  'bank.dropzone.help': 'Przeciągnij plik CSV, PDF, XLSX lub obraz z banku, kliknij, aby wybrać, albo wklej zrzut ekranu za pomocą Ctrl+V. Automatycznie dopasujemy linie do Twoich dokumentów.',
  'bank.connectHelp2': 'Pobieraj transakcje automatycznie i pozwól SuperPlumma na bieżąco księgować i uzgadniać księgi - bez ręcznego wgrywania i księgowania.',
  'bank.toast.openBankingInfo': 'Bezpieczne połączenie z bankiem przez Open Banking',
  'bank.guided.step1.title': 'Sprawdź wyciąg',
  'bank.guided.step1.sub': 'Sprawdź okres i saldo',
  'bank.guided.step2.title': 'Zatwierdź propozycje',
  'bank.guided.step2.sub': 'Sprawdź, co znalazł Plumme',
  'bank.guided.step3.title': 'Przetwórz resztę',
  'bank.guided.step3.sub': 'Wybierz, czego dotyczą płatności',
  'bank.guided.step4.title': 'Powiąż dokumenty',
  'bank.guided.step4.sub': 'Udokumentuj zakupy',
  'bank.guided.step5.title': 'Zakończ',
  'bank.guided.step5.sub': 'Sprawdź i zarchiwizuj',
  'bank.guided.stepOf': 'Krok {{step}} z {{total}}',
  'bank.guided.action.matched': 'Dopasowano do już zaksięgowanego',
  'bank.guided.action.fee': 'Opłata bankowa',
  'bank.guided.action.invoice': 'Płatność faktury',
  'bank.guided.action.purchase': 'Znany zakup',
  'bank.guided.action.sale': 'Zarejestruj sprzedaż',
  'bank.guided.suggestionFromSuper': 'Propozycja od SuperPlumma',
  'bank.guided.receivables': 'Należności od odbiorców',
  'bank.guided.suggestedCostAccount': 'Proponowane konto kosztów',
  'bank.guided.reason.sameAmount': 'Ta sama kwota i referencja płatności',
  'bank.guided.reason.textBased': 'Na podstawie tekstu, kwoty i wcześniejszych księgowań',
  'bank.guided.suggestsAction': 'Plumme proponuje: {{action}}',
  'bank.guided.vatLine': '{{account}} · {{vat}} VAT · Kwota {{amount}}',
  'bank.guided.voucherSuffix': ' · dokument: {{name}}',
  'bank.guided.out': 'WYCHODZĄCE',
  'bank.guided.in': 'PRZYCHODZĄCE',
  'bank.guided.moneyOut': 'WYPŁYWY',
  'bank.guided.moneyIn': 'WPŁYWY',
  'bank.guided.unprocessedLine': '{{direction}} · Nieprzetworzone',
  'bank.guided.bankPeriod': 'Okres bankowy',
  'bank.guided.handledLeft': '{{handled}}/{{total}} przetworzono · pozostało {{left}}',
  'bank.guided.reopenNote': 'Jeśli ponownie otworzysz uzgodnienie, okres zostanie odblokowany do kontroli. Zaksięgowane linie trzeba skorygować lub anulować ze ścieżką audytu, zanim będzie można je ponownie przetworzyć.',
  'bank.guided.toast.enterClosing': 'Wpisz saldo końcowe z wyciągu bankowego.',
  'bank.guided.err.checkIndividually': 'Co najmniej jedną propozycję trzeba sprawdzić indywidualnie.',
  'bank.guided.toast.suggestionsDone': 'Zaksięgowane i zakończone propozycje: {{count}}',
  'bank.guided.err.approveSuggestions': 'Nie udało się zatwierdzić propozycji.',
  'bank.guided.toast.roundingPosted': 'Różnica z zaokrąglenia {{amount}} została zaksięgowana',
  'bank.guided.err.roundingFailed': 'Nie udało się zaksięgować różnicy z zaokrąglenia.',
  'bank.guided.toast.markedNoVoucher': 'Zakup oznaczono jako bez dowodu księgowego',
  'bank.guided.err.saveChoice': 'Nie udało się zapisać wyboru.',
  'bank.guided.err.voucherNotFound': 'Nie znaleziono dokumentu w skrzynce odbiorczej.',
  'bank.guided.err.linkFailed': 'Nie udało się powiązać dokumentu.',
  'bank.guided.toast.noSafeHits': 'Nie znaleziono pewnych dopasowań dokumentów do powiązania.',
  'bank.guided.h.check': 'Czy okres i saldo się zgadzają?',
  'bank.guided.h.rest': 'Czego dotyczą pozostałe płatności?',
  'bank.guided.p.check': 'Sprawdź, czy to właściwy wyciąg bankowy, i wpisz saldo z końca okresu.',
  'bank.guided.p.rest': 'Wybierz, czego dotyczy każda płatność. Nie musisz znać numerów kont — Plumme pomoże Ci w księgowaniu.',
  'bank.guided.openingHint': 'Zwykle pobierane z poprzedniego zakończonego uzgodnienia.',
  'bank.guided.closingHint': 'Znajdź kwotę na wyciągu z banku.',
  'bank.guided.closingMatches': 'Saldo końcowe banku jest równe saldu obliczonemu przez Plumme.',
  'bank.guided.posting': 'Księgowanie…',
  'bank.guided.postRounding': 'Zaksięguj różnicę z zaokrągleń',
  'bank.guided.smallRounding': 'Niewielka różnica z zaokrągleń: {{amount}}',
  'bank.guided.balanceDeviates': 'Saldo różni się o {{amount}}.',
  'bank.guided.balanceDeviatesHelp': 'Przetwórz płatności w kolejnych krokach i wróć, jeśli różnica nadal występuje.',
  'bank.guided.canReturn': 'Zawsze możesz wrócić do tego kroku później.',
  'bank.guided.correctToContinue': 'Popraw salda ikoną ołówka, aby kontynuować.',
  'bank.guided.checkedContinue': 'Wyciąg sprawdzony – kontynuuj',
  'bank.guided.superIntro': 'Część pozycji dopasowano do już zaksięgowanych zapisów, a dla innych SuperPlumma zaproponowała księgowanie. Sprawdź je i naciśnij „Zatwierdź” — nic nie zostanie zaksięgowane, dopóki nie zatwierdzisz.',
  'bank.guided.count.matched': 'dopasowane do już zaksięgowanych',
  'bank.guided.count.invoice': 'płatności faktur',
  'bank.guided.count.purchase': 'znane zakupy',
  'bank.guided.count.fee': 'opłaty bankowe',
  'bank.guided.count.receipt': 'dowody znalezione automatycznie',
  'bank.guided.fixReading': 'Popraw odczyt z PDF/CSV',
  'bank.guided.suggestionsPending': 'Niezatwierdzone propozycje: {{count}}. Możesz je zatwierdzić teraz lub wrócić później.',
  'bank.guided.allSuggestionsDone': 'Wszystkie propozycje zostały przetworzone.',
});
